import { useLazyGetAllScheduleReportsQuery } from '@/store/query/ats-reports/scheduleReportsEmail';
import React, { useEffect, useState } from 'react';
import { CreateEditScheduleReportsEmail } from './CreateEditScheduleReportsEmail';
import { ScheduleReportsEmailTable } from './ScheduleReportsEmailTable';

export const ScheduleReportsEmail = ({
  modalActions,
  currentData,
  isCustomReport = false,
}) => {
  const VIEW_TYPES = {
    LIST: 'list',
    CREATE_EDIT: 'create/edit',
  };
  const [manualView, setManualView] = useState(null);
  const [selectedReport, setSelectedReport] = useState({});

  const [getAllReports, { data, isFetching }] =
    useLazyGetAllScheduleReportsQuery();

  const isEmptySchedules = data?.length === 0;

  // Compute the active view based on manual selection or data state
  const activeView =
    manualView || (data?.length > 0 ? VIEW_TYPES.LIST : VIEW_TYPES.CREATE_EDIT);

  // Helper function to set the view manually (for Edit, Create buttons)
  const setCurrentView = (view) => {
    setManualView(view);
  };

  // Reset manual view and selected report when modal closes
  useEffect(() => {
    if (!modalActions?.isOpen) {
      setManualView(null);
      setSelectedReport({});
    }
  }, [modalActions?.isOpen]);

  useEffect(() => {
    const params = isCustomReport
      ? { subject_type: `custom`, custom_report_id: currentData?.id }
      : { subject_type: currentData?.subject_type };
    getAllReports({ params });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentData?.subject_type, isCustomReport]);

  return (
    <>
      {modalActions?.isOpen && activeView === VIEW_TYPES.LIST && (
        <ScheduleReportsEmailTable
          data={data}
          isLoading={isFetching}
          setCurrentView={setCurrentView}
          setSelectedReport={setSelectedReport}
          modalActions={modalActions}
        />
      )}
      {modalActions?.isOpen && activeView === VIEW_TYPES.CREATE_EDIT && (
        <CreateEditScheduleReportsEmail
          isEmptySchedules={isEmptySchedules}
          currentData={currentData}
          modalActions={modalActions}
          selectedReport={selectedReport}
          setCurrentView={setCurrentView}
          isCustomReport={isCustomReport}
        />
      )}
    </>
  );
};
